import React from "react";

const Textarea = (props) => {
  const {
    input,
    children,
    rows,
    meta: { touched, error },
  } = props;

  return (
    <>
      <div className="flex justify-between items-center">
        {props.label && (
          <label
            htmlFor={props.id}
            className={`Form-label ${props.required ? "is-required" : ""} ${
              props.disabled ? "disabled" : ""
            } ${props.labelClass}`}
          >
            {typeof props.label === "string" ? (
              <span
                dangerouslySetInnerHTML={{ __html: props.label }}
                className="inline-block"
              ></span>
            ) : (
              props.label
            )}
          </label>
        )}
      </div>
      <textarea
        {...input}
        required={props.required}
        disabled={props.disabled}
        placeholder={props.placeholder}
        autoCorrect={props.autoCorrect}
        rows={rows}
        className={
          props.className
            ? `${props.className} ${touched && error ? "error" : ""}`
            : `w-full text-black ${props.inputClassName} ${
                touched && error ? "error" : ""
              }`
        }
      >
        {children}
      </textarea>
      {touched && error && (
        <div className="text-red-brand text-sm">{error}</div>
      )}
    </>
  );
};

Textarea.defaultProps = {
  id: undefined,
  label: undefined,
  required: undefined,
  disabled: undefined,
  placeholder: undefined,
  rows: undefined,
  autoCorrect: undefined,
};

export default Textarea;
